<!--
  @component FaceLedgerNotice — calm "connect to operate" note.
  tier:      primitive (visual atom)
  purpose:   shown where an effecting control isn't wired to the deploy
             command channel yet. Restyled to a calm, honest note (the
             operator/tenant sees "this turns on when connected"), NOT
             the old alarming "NOT_WIRED" banner with backend internals.

  Props (method/phase/detail) are accepted for call-site compatibility;
  the render no longer surfaces backend op names or phase codes. A short,
  human `detail` (if provided) is shown; long/technical detail falls back
  to the generic message.
-->
<script lang="ts">
  interface Props {
    method?: string;
    phase?: string;
    detail?: string;
  }
  const props: Props = $props();

  const message = $derived(
    props.detail && props.detail.length > 0 && props.detail.length < 90
      ? props.detail
      : "This control activates once the deploy connection is live.",
  );
</script>

<div class="note" role="note">
  <span class="dot" aria-hidden="true"></span>
  <div class="body">
    <p class="title">Connect to operate</p>
    <p class="msg">{message}</p>
  </div>
</div>

<style>
  .note {
    display: flex;
    align-items: flex-start;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-4);
    border: 0.5px solid var(--border);
    border-radius: var(--radius-md);
    background: var(--glass-fill);
    font-family: var(--type-font);
  }
  .dot {
    width: 7px;
    height: 7px;
    border-radius: var(--radius-pill);
    margin-top: 5px;
    flex-shrink: 0;
    background: var(--warning);
    opacity: 0.7;
  }
  .body { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
  .title { margin: 0; font-size: 13px; font-weight: 500; color: var(--text-primary); }
  .msg { margin: 0; font-size: 12.5px; line-height: 1.55; color: var(--text-secondary); }
</style>
